<template>
	<nav>
        <div class="links">
			<header-account-component v-if="navAccountsVisible"></header-account-component>
			<div class="line"></div>
			<router-link to="/admin/accounts" exact class="link"><span class="fa fa-globe"></span>Accounts<span class="count">{{ accounts.length - 1 }}</span></router-link>
			<router-link to="/admin/accounts/users" exact class="link"><span class="fa fa-user-friends"></span>Account Users<span class="fa fa-chevron-right pointer"></span></router-link>
			<router-link to="/admin/dashboard" exact class="link"><span class="fa fa-wrench"></span>Operations<span class="fa fa-chevron-right pointer"></span></router-link>
			<router-link to="/admin/deployments" exact class="link"><span class="fa fa-rocket"></span>Deployments<span class="fa fa-chevron-right pointer"></span></router-link>
		</div>
	</nav>
</template>

<script>

import { mapGetters, mapState } from 'vuex';

import HeaderAccountComponent from '../../HeaderAccountComponent';

export default {

	computed: {
		...mapGetters([ 'modules', 'navCounts', 'currentAccount', 'masterAccount', 'accounts' ]),

		...mapState({
			accountMenuOpen: state => state.layout.accountMenuOpen,
			navAccountsVisible: state => state.layout.navAccountsVisible,
		}),

		visibleModules() {
			const primaryModules = this.modules.filter(module => ['submodule','child'].indexOf(module.subtype) === -1 && !!module.can_view);
			const access = this.currentAccount.access || false;
			if (!access) return [];
			if (access.access_type !== 'BASIC') return primaryModules;

			const permissions = access.access_permissions.split(',').filter(Boolean);
			return primaryModules.filter(module => {
				return permissions.indexOf(module.slug) !== -1;
			});
		},

		canManageInquiries() {
			const access = this.currentAccount.access || false;
			if (!access) return false;
			if (access.access_type === 'BASIC') {
				const permissions = access.access_permissions.split(',').filter(Boolean);
				return permissions.indexOf('_inquiries') !== -1 || permissions.indexOf('inquiries') !== -1;
			}

			return true;
		},

	},

	methods: {

		navCount(slug) {
			return this.navCounts[ slug ] || 0;
		},

		closeAccountMenu() {
			this.$store.dispatch('closeAccountMenu');
		},

	},

	watch: {
		'$route': function() {
			this.$store.dispatch('closeAccountMenu');
		},
	},

	components: {
		HeaderAccountComponent,
	}

};

</script>
